module.exports = __webpack_public_path__ + "br.svg?7118606b76a22d5f3f41b9b43b06a3f6";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/br.svg
// module id = 1013
// module chunks = 27